import React, { Fragment } from "react";

import {
  DropdownToggle,
  DropdownMenu,
  Button,
  NavLink,
  UncontrolledButtonDropdown,
} from "reactstrap";

import * as UsersService from "../../../services/users/api_user";
import { toast, Bounce } from "react-toastify";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import city3 from "../../../assets/architect/utils/images/dropdown-header/city3.jpg";
import avatar6 from "../../../assets/architect/utils/images/avatars/2.jpg";

class UserBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      user: {},
    };
  }

  /*********************************** LIFECYCLE ***********************************/
  componentDidMount() {
    this._isMounted = true;
    const user = UsersService.getCurrentUser();
    if (this._isMounted && user != null) {
      this.setState({ user });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /*********************************** METHODS ***********************************/
  notify2 = () =>
    (this.toastId = toast(
      "You don't have any new items in your calendar for today! Go out and play!",
      {
        transition: Bounce,
        closeButton: true,
        autoClose: 5000,
        position: "bottom-center",
        type: "success",
      }
    ));

  /*********************************** RENDER ***********************************/
  render() {
    const { user } = this.state;

    return (
      <Fragment>
        <div className="header-btn-lg pr-0">
          <div className="widget-content p-0">
            <div className="widget-content-wrapper">
              <div className="widget-content-left">
                <UncontrolledButtonDropdown>
                  <DropdownToggle color="link" className="p-0">
                    <img
                      width={42}
                      className="rounded-circle"
                      src={user.photo !== undefined ? user.photo : avatar6}
                      alt=""
                    />
                    <FontAwesomeIcon
                      className="ml-2 opacity-8"
                      icon={faAngleDown}
                    />
                  </DropdownToggle>
                  <DropdownMenu right className="rm-pointers dropdown-menu-lg">
                    <div className="dropdown-menu-header">
                      <div className="dropdown-menu-header-inner bg-info">
                        <div
                          className="menu-header-image opacity-3"
                          style={{
                            backgroundImage: "url(" + city3 + ")",
                          }}
                        />
                        <div className="menu-header-content text-left">
                          <div className="widget-content p-0">
                            <div className="widget-content-wrapper">
                              <div className="widget-content-left mr-3">
                                <img
                                  width={42}
                                  className="rounded-circle"
                                  src={
                                    user.photo !== undefined
                                      ? user.photo
                                      : avatar6
                                  }
                                  alt=""
                                />
                              </div>
                              <div className="widget-content-left">
                                <div className="widget-heading">
                                  {user.name !== undefined
                                    ? user.name
                                    : "INVALID NAME"}
                                </div>
                                <div className="widget-subheading opacity-8">
                                  {user.bio !== undefined
                                    ? user.bio
                                    : "PICAdvanced"}
                                </div>
                              </div>
                              <div className="widget-content-right mr-2">
                                <NavLink
                                  href="/#/logout"
                                  className="btn-pill btn-shadow btn-shine"
                                  color="focus"
                                >
                                  <Button
                                    className="btn-pill btn-shadow btn-shine"
                                    color="focus"
                                  >
                                    Logout
                                  </Button>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-center">
                      <b>Copyright &copy; PICAdvanced {new Date().getFullYear()}</b>
                    </div>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </div>
              <div className="widget-content-left  ml-3 header-user-info">
                <div className="widget-heading">
                  {user.name !== undefined ? user.name : "USER NAME"}
                </div>
                <div className="widget-subheading">
                  {user.bio !== undefined ? user.bio : "PICAdvanced"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default UserBox;



// WEBPACK FOOTER //
// ./src/Layout/AppHeader/Components/UserBox.js